import React, { useEffect, useRef } from 'react';
import {ButtonActionStyled, OptimizeInputsContainerStyled} from "../../../styled/Resume";
import { FaCaretDown } from "react-icons/fa";
import {useTheme} from "../../UI/Theme/ThemeContext";
import { CountryDropdown, RegionDropdown } from 'react-country-region-selector';
import { MdDelete } from "react-icons/md";
import { FaPlus } from "react-icons/fa6";
import PhoneInput from "react-phone-input-2";
import { isIOSStandalonePWA } from "../../../utils/client-functions";



const InputHandler = (props) => {
  const {
        id,
        type,
        label,
        list,
        country,
        placeholder,
        value,
        name,
        onChange,
        required,
        handleDelete,
        handleAdd,
        languageValue,
        languageName,
        languageLabel,
        languageList,
        languageOnChange,
        levelValue,
        levelName,
        levelLabel,
        levelList,
        levelOnChange,
        handleDeleteLang,
        disabled,
        onBlur,
        inputStyle
    } = props;
    const {themeName} = useTheme();

  // Auto-resize for multiline up to 6 rows
  const textAreaRef = useRef(null);
  const autoResize = (el) => {
    if (!el) return;
    el.style.height = 'auto';
    const computed = window.getComputedStyle(el);
    const lineHeight = parseFloat(computed.lineHeight) || 15;
    const paddingTop = parseFloat(computed.paddingTop) || 0;
    const paddingBottom = parseFloat(computed.paddingBottom) || 0;
    const maxRows = 5;
    const maxHeight = lineHeight * maxRows + paddingTop + paddingBottom;
    const newHeight = Math.min(el.scrollHeight, maxHeight);
    el.style.height = `${newHeight}px`;
    // show thin scrollbar only when content exceeds limit
    el.style.overflowY = el.scrollHeight > maxHeight ? 'auto' : 'hidden';
  };

  useEffect(() => {
    if (type === 'textBox' && textAreaRef.current) autoResize(textAreaRef.current);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [value, type]);

  return (
      <>
        <OptimizeInputsContainerStyled theme={themeName}>
            {
                type === "text" &&
                  <input
                    className="inputText"
                    id={id}
                    name={name}
                    value={value}
                    onChange={onChange}
                    onBlur={onBlur}
                    type="text"
                    disabled={disabled}
                    required={required}
                    placeholder={label}
                    style={inputStyle}
                />
            }
            {
              type === "education" &&
              <input
                className="inputText"
                id={id}
                name={name}
                value={value}
                onChange={onChange}
                type={name === 'date' ? 'date' : 'text'}
                disabled={disabled}
                required={required}
                placeholder={label}
                style={inputStyle}
              />
            }

            {
              type === "links" &&
              <div className="addLinks">
                <input
                  className="inputText"
                  id={id}
                  name={name}
                  value={value}
                  onChange={onChange}
                  type="text"
                  required={required}
                  placeholder={label}
                  style={inputStyle}
                />
                <span className="actions del" onClick={handleDelete}> <MdDelete /> </span>
                <span className="actions add" onClick={handleAdd}> <FaPlus /> </span>
              </div>

            }

            {
                type === "email" &&
                <input
                    className="inputText"
                    id={id}
                    name={name}
                    value={value}
                    onChange={onChange}
                    type="email"
                    disabled={disabled}
                    required={required}
                    placeholder={label}
                    style={inputStyle}
                />
            }
            {
              type === "mobile" &&
              <PhoneInput
                  country='ng'
                  inputClass="inputMobile"
                  buttonClass="countryBox"
                  onChange={onChange}
                  required={required}
                  value={value}
                  enableSearch={true}
              />

            }

            {
              type === "textBox" &&
              <textarea
                  className="textarea"
                  name={name}
                  value={value}
                  onChange={onChange}
                  ref={textAreaRef}
                  onInput={(e) => autoResize(e.target)}
                  type="text"
                  placeholder={placeholder}
                  disabled={disabled}
                  style={inputStyle}
              />
            }

            {type === "date" && (
              <input
                className="inputText"
                id={id}
                name={name}
                value={value}
                onChange={onChange}
                type="date"
                disabled={disabled}
                required={required}
                placeholder={label}
                style={inputStyle}
              />
            )}

            {type === "select" && label === "Type of Connection" && (
              <div className="selectWrapper">
                <select
                  className="inputText"
                  value={value || ""}
                  onChange={onChange}
                  name={name}
                  disabled={disabled}
                >
                  <option value="">{label}</option>
                  {Array.isArray(list) && list.map((option, index) => (
                    <option key={index} value={option.name}>
                      {option.name}
                    </option>
                  ))}
                </select>
                <FaCaretDown className="icon"/>
              </div>
            )}

            {type === "select" && label === "Country" && (
              <div className="selectWrapper">
                <CountryDropdown
                    className="inputText"
                    name={name}
                    onChange={onChange}
                    value={value}
                    required={required}
                    disabled={disabled}
                />
                <FaCaretDown className="icon"/>
              </div>
            )}

            {type === "select" && label === "State" && (
                <div className="selectWrapper">
                    <RegionDropdown
                        className="inputText"
                        country={country}
                        name={name}
                        onChange={onChange}
                        value={value}
                        required={props.required}
                        disabled={disabled}
                    />
                    <FaCaretDown className="icon"/>
                </div>
            )}

            {type === "experience" &&
                <div className="experience">
                    {name !== "workLink" ? <p>{label}<sup>*</sup></p> : <p>Related Link</p>}
                    <input
                      className="inputText"
                      name={name}
                      value={value}
                      onChange={onChange}
                      type={(label === 'From' || label === 'To') ? 'date' : 'text'}
                      disabled={disabled}
                      required={required}
                      placeholder={label}
                      style={inputStyle}
                    />
                </div>
            }

            {/* Generic select fallback for other labels */}
            {type === "select" && !["Type of Connection", "Country", "State"].includes(label) && (
              <div className="selectWrapper">
                <select
                  className="inputText"
                  value={value || ""}
                  onChange={onChange}
                  name={name}
                  disabled={disabled}
                >
                  <option value="">{label}</option>
                  {Array.isArray(list) && list.map((option, index) => {
                    const optValue = typeof option === 'object' ? (option.value ?? option.name) : option;
                    const optLabel = typeof option === 'object' ? (option.label ?? option.name) : String(option);
                    return (
                      <option key={index} value={optValue}>
                        {optLabel}
                      </option>
                    );
                  })}
                </select>
                <FaCaretDown className="icon"/>
              </div>
            )}

            {type === "checkbox" &&
              <div className="checkboxWrapper">
                <input
                  className={isIOSStandalonePWA() ? "checkbox-ios-pwa" : ""}
                  type="checkbox"
                  id={id}
                  name={name}
                  checked={!!value}
                  onChange={onChange}
                  style={inputStyle}
                />
                <label htmlFor={id}> {label}</label>
              </div>

            }

            {
              type === "language" && (
                <div className="languageWrapper">
                  <div style={{ display: "flex", gap: "0.5rem" }}>
                    {/* 🔹 Language Select */}
                    <div className="selectWrapper language">
                      <select
                        className="inputSelect"
                        value={languageValue || ""} // ✅ ensure controlled input
                        onChange={languageOnChange} // ✅ handle updates
                        name={languageName || 'language'}
                        disabled={disabled}
                      >
                        <option value="">{languageLabel}</option>
                        {languageList.map((option, index) => (
                          <option key={index} value={option.name}>
                            {option.name}
                          </option>
                        ))}
                      </select>
                      <FaCaretDown className="icon" />
                    </div>

                    {/* 🔹 Level Select */}
                    <div className="selectWrapper level">
                      <select
                        className="inputSelect"
                        value={levelValue || ""} // ✅ controlled
                        onChange={levelOnChange} // ✅ handle updates
                        name={levelName || 'level'}
                        disabled={disabled}
                      >
                        <option value="">{levelLabel}</option>
                        {levelList.map((option, index) => (
                          <option key={index} value={option.name}>
                            {option.name}
                          </option>
                        ))}
                      </select>
                      <FaCaretDown className="icon" />
                    </div>
                  </div>

                  {type === "language" && (
                    <ButtonActionStyled skill>
                      <span className="del" onClick={handleDeleteLang}>
                        <MdDelete />
                      </span>
                    </ButtonActionStyled>
                  )}
                </div>
              )
            }
        </OptimizeInputsContainerStyled>
      </>
    )
}

export default InputHandler;